import React from 'react';

import laboratorio from '../images/laboratorioClinico.jpg';
import automotriz from '../images/Automotriz.jpg';
import contabilidad from '../images/contabilidad1.jpg';
import enfermeria from '../images/enfermeria.jpg';
import informatica from '../images/informatica.jpg';


const Oferta = () =>{


      return(
          <div>

            <div className='container' style={{marginTop:50,backgroundColor:"aliceblue",padding:10}} >
                <div className='row'>
                    <div className='col-12 col-md-8'>
                        <h4><b>Laboratorio Clinico</b></h4>
                        <p>El área de la salud es de suma importancia ya que en general todos en algún momento carecemos de ella necesitamos profesionistas que sean capaces de remediar nuestros males, por lo que te preparamos en esta especialidad para realizar análisis y tomas de muestras del cuerpo humano, así mismo podrás continuar tus estudios en cualquier carrera de ciencias biológicas a nivel Universitario.</p><br/>
                        <span><b>Area de trabajo:</b></span><br/>
                        <span>
                            Todas las instituciones de Salud a nivel Municipal, Estatal, Federal y Sector Privado.<br></br>
                            Crear tu propio negocio en dicha rama ya que contaras al termino con una Cedula y Título Profesional. 
                        </span>
                    </div>
                    <div className='col-12 col-md-4'>
                        <img alt="" src={laboratorio} style={{width:"100%", height:300, objectFit:"cover"}}></img>
                    </div>
                </div>
            </div>

            <div className='container' style={{marginTop:50,backgroundColor:"aliceblue",padding:10}} >
                <div className='row'>
                    <div className='col-12 col-md-4'>
                        <img alt="" src={automotriz} style={{width:"100%", height:300, objectFit:"cover"}}></img>
                    </div>
                    <div className='col-12 col-md-8'>
                        <h4><b>Mantenimiento Automotriz</b></h4>
                        <p>Esta especialidad te capacita en todo lo relacionado con el mantenimiento correctivo y preventivo de los automóviles, siendo esto bastante atractivo para todos los jóvenes hombres y mujeres que tengan interés en emprender su propio negocio o trabajar en agencias automovilísticas y/o poder continuar tus estudios universitarios</p><br/>
                        <span><b>Campo de trabajo:</b></span><br/>
                        <span>
                            Todas las Empresas Automovilísticas a nivel Municipal, Estatal, Federal y del sector privado.
                            Crear tu propio negocio en dicha rama ya que contaras al termino con una Cedula y Titulo Profesional.
                        </span>
                    </div>
                </div>
            </div>

            <div className='container' style={{marginTop:50,backgroundColor:"aliceblue",padding:10}} >
                <div className='row'>
                    <div className='col-12 col-md-8'>
                        <h4><b>Contabilidad</b></h4>
                        <p>La contabilidad es una especialidad que es necesaria en todos los ámbitos empresariales, llámense micro, pequeñas, medianas o grandes empresas, por lo que en nuestra sociedad productiva los contadores son muy necesarios, en nuestra institución te capacitamos para poderte desempeñar como técnico en contabilidad y poder hacerte cargo de la contabilidad de algún negocio, también podrás continuar tus estudios ya sea en el área de contabilidad, administración o/y afines a nivel Universitario.</p> <br/>
                        <span><b>Campo de trabajo:</b></span>
                        <span>
                            Todas las Empresas a nivel Municipal, Estatal, Federal y del sector privado.
                            Crear tu propio negocio en dicha rama ya que contaras al termino con una Cedula y Título Profesional
                        </span>
                    </div>
                    <div className='col-12 col-md-4'>
                        <img alt="" src={contabilidad} style={{width:"100%", height:300, objectFit:"cover"}}></img>
                    </div>
                </div>
            </div>

            <div className='container' style={{marginTop:50,backgroundColor:"aliceblue",padding:10}} >
                <div className='row'>
                    <div className='col-12 col-md-4'>
                        <img alt="" src={enfermeria} style={{width:"100%", height:300, objectFit:"cover"}}></img>
                    </div>
                    <div className='col-12 col-md-8'>
                        <h4><b>Enfermeria</b></h4>
                        <p>La Especialidad ya cuenta con el  bachillerato, por lo que  tiene un amplio campo laboral siendo una carrera con un gran futuro si lo que te gustan son las ciencias de la salud, al término puedes continuar con la Licenciatura en el área de salud. </p><br/>
                        <span><b>Campo de trabajo:</b></span><br/>
                        <span>
                            Todas las instituciones de Salud a nivel Municipal, Estatal, Federal y en forma particular.
                            Al termino de tus estudios realizaras un servicio social para concluir tu carrera y poder obtener tu Cedula y Titulo Profesional.
                        </span>
                    </div>
                </div>
            </div>

            <div className='container' style={{marginTop:50,marginBottom:50,backgroundColor:"aliceblue",padding:10}} >
                <div className='row'>
                    <div className='col-12 col-md-8'>
                        <h4><b>Analisis de datos e informacion</b></h4>
                        <p>La Ciencia de Datos (Data Science) se encarga de analizar grandes volúmenes de información con la ayuda de la inteligencia artificial para mejorar el manejo de la información., con toda esta información, el profesional de Ciencia de Datos puede descubrir tendencias, predecir el futuro y anticiparlo.</p><br/>
                        <span><b>Campo de trabajo:</b></span>
                        <span>Industria manufacturera, Área de salud, Sector público, Agencias de publicidad, Empresas financieras, Consultorías independientes.</span>
                    </div>
                    <div className='col-12 col-md-4'>
                        <img alt="" src={informatica} style={{width:"100%", height:300, objectFit:"cover"}}></img>
                    </div>
                </div>
            </div>

            
          </div>
      )

}

export default Oferta;